(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flip-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flip-cards-section')) {
    customElements.define(
      'flip-cards-section',
      class FlipCardsSection extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;

          this.abortController = new AbortController();
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.tiltEnabled = this.dataset.tiltEnabled === 'true';
          this.tiltStrength = Number(this.dataset.tiltStrength) || 8;
          this.cards = Array.from(this.querySelectorAll('[data-flip-card]'));

          this.cards.forEach((card) => this.bindCard(card));

          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const item = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
              const card = item ? item.querySelector('[data-flip-card]') : null;
              if (!card) return;
              this.setCardState(card, true);
              item.scrollIntoView({ behavior: this.motionQuery.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
            },
            { signal: this.abortController.signal }
          );
        }

        disconnectedCallback() {
          if (!this.abortController) return;
          this.abortController.abort();
          this.abortController = null;
        }

        bindCard(card) {
          const signal = this.abortController.signal;
          const scene = card.querySelector('[data-card-scene]');
          let pointerActive = false;
          let pointerId = null;
          let startX = 0;
          let startY = 0;
          let dragged = false;

          card.addEventListener(
            'pointerdown',
            (event) => {
              pointerActive = true;
              pointerId = event.pointerId;
              startX = event.clientX;
              startY = event.clientY;
              dragged = false;
            },
            { signal }
          );

          card.addEventListener(
            'pointermove',
            (event) => {
              if (pointerActive && event.pointerId === pointerId) {
                const distanceX = Math.abs(event.clientX - startX);
                const distanceY = Math.abs(event.clientY - startY);
                if (distanceX > 8 || distanceY > 8) dragged = true;
              }

              if (!scene || event.pointerType !== 'mouse') return;
              if (!this.tiltEnabled || !this.pointerQuery.matches || this.motionQuery.matches) return;

              const bounds = card.getBoundingClientRect();
              const xRatio = (event.clientX - bounds.left) / bounds.width - 0.5;
              const yRatio = (event.clientY - bounds.top) / bounds.height - 0.5;
              scene.style.setProperty('--fc-tilt-x', `${-yRatio * this.tiltStrength}deg`);
              scene.style.setProperty('--fc-tilt-y', `${xRatio * this.tiltStrength}deg`);
            },
            { signal }
          );

          const finishPointer = (event) => {
            if (!pointerActive || event.pointerId !== pointerId) return;
            pointerActive = false;
            pointerId = null;
            if (dragged) card.dataset.suppressClick = 'true';
          };

          card.addEventListener('pointerup', finishPointer, { signal });
          card.addEventListener('pointercancel', finishPointer, { signal });

          card.addEventListener(
            'click',
            (event) => {
              if (card.dataset.suppressClick === 'true') {
                event.preventDefault();
                card.dataset.suppressClick = 'false';
                return;
              }
              this.toggleCard(card);
            },
            { signal }
          );

          const resetTilt = () => {
            if (!scene) return;
            scene.style.setProperty('--fc-tilt-x', '0deg');
            scene.style.setProperty('--fc-tilt-y', '0deg');
          };

          card.addEventListener('pointerleave', resetTilt, { signal });
          card.addEventListener('blur', resetTilt, { signal });
        }

        toggleCard(card) {
          const nextState = card.getAttribute('aria-pressed') !== 'true';
          this.setCardState(card, nextState);
        }

        setCardState(card, isFlipped) {
          const front = card.querySelector('[data-card-front]');
          const back = card.querySelector('[data-card-back]');
          card.setAttribute('aria-pressed', String(isFlipped));
          card.setAttribute('aria-label', isFlipped ? card.dataset.backLabel : card.dataset.frontLabel);
          if (front) front.setAttribute('aria-hidden', String(isFlipped));
          if (back) back.setAttribute('aria-hidden', String(!isFlipped));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scene-hotspot-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scene-hotspot-tabs')) {
    class SceneHotspotTabs extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-scene-track]');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.track) this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.mobileQuery.addEventListener('change', this.handleBreakpointChange);
        this.handleBreakpointChange();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
        if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.handleBreakpointChange);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.initialized = false;
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      get panels() {
        return Array.from(this.querySelectorAll('[role="tabpanel"]'));
      }

      get isMobile() {
        return this.mobileQuery.matches;
      }

      handleClick(event) {
        const directionButton = event.target.closest('[data-scene-direction]');
        if (directionButton && this.contains(directionButton) && this.isMobile) {
          const panel = directionButton.closest('[data-scene-panel]');
          const currentIndex = this.panels.indexOf(panel);
          const direction = directionButton.dataset.sceneDirection;
          const targetIndex = direction === 'previous' ? currentIndex - 1 : currentIndex + 1;
          const targetTab = this.tabs[targetIndex];

          if (targetTab) this.activateTab(targetTab, false, true, true);
          return;
        }

        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        this.activateTab(tab, false);
      }

      handleKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;

        const tabs = this.tabs;
        const currentIndex = tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activateTab(tabs[nextIndex], true);
      }

      handleBlockSelect(event) {
        const panel = event.target.closest('[data-scene-panel]');
        if (!panel || !this.contains(panel)) return;
        const tab = this.tabs.find((item) => item.getAttribute('aria-controls') === panel.id);
        if (tab) this.activateTab(tab, false, false, true);
      }

      handleBreakpointChange() {
        const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
        if (!selectedTab) return;
        this.setActiveState(selectedTab);

        if (this.isMobile) {
          requestAnimationFrame(() => this.scrollToPanel(selectedTab, 'auto'));
        } else if (this.track) {
          this.track.scrollLeft = 0;
        }
      }

      handleScroll() {
        if (!this.isMobile || !this.track || this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          const trackRect = this.track.getBoundingClientRect();
          const trackCenter = trackRect.left + trackRect.width / 2;
          let closestPanel = null;
          let closestDistance = Infinity;

          this.panels.forEach((panel) => {
            const panelRect = panel.getBoundingClientRect();
            const panelCenter = panelRect.left + panelRect.width / 2;
            const distance = Math.abs(panelCenter - trackCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestPanel = panel;
            }
          });

          if (!closestPanel) return;
          const tab = this.tabs.find((item) => item.getAttribute('aria-controls') === closestPanel.id);
          if (tab) this.setActiveState(tab);
        });
      }

      setActiveState(tab) {
        const controlledPanelId = tab.getAttribute('aria-controls');

        this.tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel.id === controlledPanelId;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', this.isMobile ? 'false' : isActive ? 'false' : 'true');
        });
      }

      scrollToPanel(tab, behavior) {
        if (!this.track) return;
        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (!panel) return;
        const trackRect = this.track.getBoundingClientRect();
        const panelRect = panel.getBoundingClientRect();
        const left = this.track.scrollLeft + panelRect.left - trackRect.left;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left, behavior: reduceMotion ? 'auto' : behavior });
      }

      activateTab(tab, shouldFocus, shouldTransition = true, shouldScroll = true) {
        if (!tab) return;

        if (this.isMobile) {
          this.setActiveState(tab);
          if (shouldScroll) this.scrollToPanel(tab, 'smooth');
          if (shouldFocus) requestAnimationFrame(() => tab.focus());
          return;
        }

        if (tab.getAttribute('aria-selected') === 'true') {
          if (shouldFocus) tab.focus();
          return;
        }

        const update = () => this.setActiveState(tab);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (shouldTransition && document.startViewTransition && !reduceMotion) {
          document.startViewTransition(update);
        } else {
          update();
        }

        if (shouldFocus) requestAnimationFrame(() => tab.focus());
      }
    }

    customElements.define('scene-hotspot-tabs', SceneHotspotTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-from-social"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-social-video-section]').forEach(function(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    var track = section.querySelector('[data-social-video-track]');
    if (!track) return;
    var previous = section.querySelector('[data-social-video-previous]');
    var next = section.querySelector('[data-social-video-next]');
    function scrollAmount() { return track.querySelector('[data-social-video-card]').getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0); }
    if (previous) previous.addEventListener('click', function() { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function() { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
    section.querySelectorAll('[data-social-video-card]').forEach(function(card) {
      var video = card.querySelector('video');
      var toggle = card.querySelector('[data-social-video-toggle]');
      var sound = card.querySelector('[data-social-video-sound]');
      if (!video) return;
      video.addEventListener('play', function() { card.classList.add('is-playing'); });
      video.addEventListener('pause', function() { card.classList.remove('is-playing'); });
      if (toggle) toggle.addEventListener('click', function() { video.paused ? video.play() : video.pause(); });
      if (sound) sound.addEventListener('click', function() { video.muted = !video.muted; card.classList.toggle('is-unmuted', !video.muted); sound.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video'); });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
